module.exports = __webpack_public_path__ + "static/media/disney.86e34b80.svg";